import { computed, Service, signal } from '@angular/core';

import {
    ActIdTip,
    AdresaTip,
    Asigurator,
    Cmj,
    CmjServicii,
    DocStatus,
    DocTip,
    EmcTip,
    Facultate,
    FacultateDocTip,
    Judet,
    MedicActiuniTip,
    MedicStatus,
    Ppu,
    PpuDoc,
    PpuGrad,
    PpuGrup,
    PpuTip,
    Registru,
    Tara,
    Titlu,
} from '../models/registre.model';

const initialState: Registru = {
    tara: [],
    judet: [],
    act_id_tip: [],
    facultate: [],
    facultate_doc_tip: [],
    ppu: [],
    ppu_tip: [],
    ppu_grad: [],
    ppu_doc: [],
    ppu_grup: [],
    titlu: [],
    adresa_tip: [],
    asigurator: [],
    cmj: [],
    medic_status: [],
    doc_status: [],
    doc_tip: [],
    actiuni_tip: [],
    cmj_servicii: [],
    emc_tip: [],
};

/** Registrele (nomenclatoarele) incarcate de la API la autentificare. */
@Service()
export class RegistreStore {
    private readonly state = signal<Registru>(initialState);

    /** Toate registrele, ca un singur obiect. */
    readonly registru = this.state.asReadonly();
    readonly tara = computed(() => this.state().tara);
    readonly judet = computed(() => this.state().judet);
    readonly actIdTip = computed(() => this.state().act_id_tip);
    readonly facultate = computed(() => this.state().facultate);
    readonly facultateDocTip = computed(() => this.state().facultate_doc_tip);
    readonly ppu = computed(() => this.state().ppu);
    readonly ppuTip = computed(() => this.state().ppu_tip);
    readonly ppuGrad = computed(() => this.state().ppu_grad);
    readonly ppuDoc = computed(() => this.state().ppu_doc);
    readonly ppuGrup = computed(() => this.state().ppu_grup);
    readonly titlu = computed(() => this.state().titlu);
    readonly adresaTip = computed(() => this.state().adresa_tip);
    readonly asigurator = computed(() => this.state().asigurator);
    readonly cmj = computed(() => this.state().cmj);
    readonly medicStatus = computed(() => this.state().medic_status);
    readonly docStatus = computed(() => this.state().doc_status);
    readonly docTip = computed(() => this.state().doc_tip);
    readonly actiuniTip = computed(() => this.state().actiuni_tip);
    readonly cmjServicii = computed(() => this.state().cmj_servicii);
    readonly emcTip = computed(() => this.state().emc_tip);

    setTari(tara: Tara[]) {
        this.state.update(state => ({ ...state, tara: tara }));
    }

    setJudete(judet: Judet[]) {
        this.state.update(state => ({ ...state, judet: judet }));
    }

    setActIdTip(actIdTip: ActIdTip[]) {
        this.state.update(state => ({ ...state, act_id_tip: actIdTip }));
    }

    setFacultate(facultate: Facultate[]) {
        this.state.update(state => ({ ...state, facultate: facultate }));
    }

    setFacDocTip(facultateDocTip: FacultateDocTip[]) {
        this.state.update(state => ({ ...state, facultate_doc_tip: facultateDocTip }));
    }

    setPpu(ppu: Ppu[]) {
        this.state.update(state => ({ ...state, ppu: ppu }));
    }

    setPpuTip(ppuTip: PpuTip[]) {
        this.state.update(state => ({ ...state, ppu_tip: ppuTip }));
    }

    setPpuGrad(ppuGrad: PpuGrad[]) {
        this.state.update(state => ({ ...state, ppu_grad: ppuGrad }));
    }

    setPpuDoc(ppuDoc: PpuDoc[]) {
        this.state.update(state => ({ ...state, ppu_doc: ppuDoc }));
    }

    setPpuGrup(ppuGrup: PpuGrup[]) {
        this.state.update(state => ({ ...state, ppu_grup: ppuGrup }));
    }

    setTitlu(titlu: Titlu[]) {
        this.state.update(state => ({ ...state, titlu: titlu }));
    }

    setAdresaTip(adresaTip: AdresaTip[]) {
        this.state.update(state => ({ ...state, adresa_tip: adresaTip }));
    }

    setAsigurator(asigurator: Asigurator[]) {
        this.state.update(state => ({ ...state, asigurator: asigurator }));
    }

    setCmj(cmj: Cmj[]) {
        this.state.update(state => ({ ...state, cmj: cmj }));
    }

    setMedicStatus(medicStatus: MedicStatus[]) {
        this.state.update(state => ({ ...state, medic_status: medicStatus }));
    }

    setDocStatus(docStatus: DocStatus[]) {
        this.state.update(state => ({ ...state, doc_status: docStatus }));
    }

    setDocTip(docTip: DocTip[]) {
        this.state.update(state => ({ ...state, doc_tip: docTip }));
    }

    setMedicActiuniTip(actiuniTip: MedicActiuniTip[]) {
        this.state.update(state => ({ ...state, actiuni_tip: actiuniTip }));
    }

    setCmjServicii(cmjServicii: CmjServicii[]) {
        this.state.update(state => ({ ...state, cmj_servicii: cmjServicii }));
    }

    setEmcTip(emcTip: EmcTip[]) {
        this.state.update(state => ({ ...state, emc_tip: emcTip }));
    }
}
